import common from './common.json'
import countryCurrency from './country-currency.json'
import dataTable from './data-table.json'
import errors from './errors.json'
import requests from './requests.json'
import sidebar from './sidebar.json'
import tour from './tour.json'
import translations from './translations.json'

export default {
  translations,
  common,
  requests,
  tour,
  sidebar,
  errors,
  'data-table': dataTable,
  countryCurrency,
}
